<template>
  <div class="addSu">
    <mt-header title="发布信息">
      <span slot="left" @click="()=>this.$router.back()">
        <i class="iconfont icon-left"></i>
        Return
      </span>
    </mt-header>
    <div class="addContent">
      <h3>分类</h3>
      <p class="choose">
        <button v-for="item in classList" :key="item.id">{{item.name}}</button>
      </p>
      <h3>内容描述</h3>
      <!-- <input type="text"/> -->
      <textarea name="" cols="30" rows="10" placeholder="请输入要输入的内容"></textarea>
      <h3>上传图片</h3>
      <!--上传组件 -->
      <AddImg/>
      <p><i class="iconfont "></i>多次连续发布重复需求可能将被封号</p>
      <!-- 用p加下边框 -->
      <div>
        <input type="checkbox" name="vehicle" value="Car" checked="checked" /> 
        我已阅读并同意<span>《平台用户服务协议》</span>
      </div>
      <button>立即发布</button>
    </div>
  </div>
</template>

<script>
import { Header } from 'mint-ui';
import "mint-ui/lib/header/style.css"
import AddImg from "./addImg"
export default {
  components:{
    'mt-header':Header,
    AddImg
  },
  data(){
    return{
      classList:[
        {
          id:1,
          name:"石油石化",
        },
        {
          id:2,
          name:"页岩气",
        },
        {
          id:3,
          name:"海洋石油天然气",
        },
        {
          id:4,
          name:"管道与存储",
        },
        {
          id:5,
          name:"海工装备",
        },
        {
          id:6,
          name:"安全防护",
        },
        {
          id:7,
          name:"天然气",
        },
        {
          id:8,
          name:"防爆仪器仪表",
        },
        {
          id:9,
          name:"智能油田",
        },
        {
          id:10,
          name:"油田土壤修复",
        },
        {
          id:11,
          name:"其他",
        }
      ],
    }
  },
  

}
</script>

<style>
  .addSu{
    width: 100%;
    background-color: white;
  }
  .mint-header{
    height: 40px;
    background-color: #008baf;
    position: relative;
    z-index: 10;
  }
  .choose button{
    margin: 4px;
    padding: 2px 10px;
    border: none;
    border-radius: 16px;
    font-size: 12px;
    outline: none;
  }
  .addContent{
    padding: 0 10px;
  }
  .addContent >h3{
    font-size: 18px;
    font-weight: 600;
    padding: 10px 0;

  }

</style>